import StepsSectionImplementation from '../implementation/sections/StepsSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiStepsSectionDTO,
  StepsSectionDTO,
} from '@lib/strapi/dtos/components/sections/stepsSection.dto';

const StepsSection = (props: ComponentProps<StepsSectionDTO>) => {
  return <StepsSectionImplementation {...props}></StepsSectionImplementation>;
};

export default StepsSection;
